import { Listado_Planos } from './../../../models/listado_planos.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'app-listado-planos',
  templateUrl: './listado-planos.component.html',
  styleUrls: ['./listado-planos.component.css'],
  providers: [FormService]
})
export class ListadoPlanosComponent {
  @ViewChild('openModal') openModal: TemplateRef<any>;
  @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;

  public rows = [];
  public actualRow;
  public Listado_Planos: Listado_Planos;
  public formulario;
  public temp_clasif;
  public matcher = new FormService();
  public form;
  public form152 = false;
  public form154 = false;


  constructor(private dialog: MatDialog) {
    this.form = localStorage.getItem("form")

    if (this.form == "1-5.2") {
        this.form152 = true;
    }

    if (this.form == "1-5.4") {
      this.form154 = true;
  }



    this.formulario = new FormGroup({
      rae: new FormControl(''),
      plano: new FormControl(''),
      contenido: new FormControl(''),
      nota: new FormControl(''),

    })
    if (!JSON.parse(localStorage.getItem("Listado_Planos"))) {
      localStorage.setItem("Listado_Planos", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("Listado_Planos"));

    }
    this.Listado_Planos = {
      rae: "",
      plano: "",
      contenido: "",
      nota: "",
    };
    this.temp_clasif = {
      rae: "",
      plano: "",
      contenido: "",
      nota: "",
    };
  }

  add_clasificacion() {


    this.actualRow = localStorage.getItem("Listado_Planos");
    this.rows = JSON.parse(this.actualRow);

    if (!this.formulario.value.plano || !this.formulario.value.contenido ) {
      console.log("no se ingresaron datos");
      this.dialog.open(this.openModalNODATA);

    } else {
      this.rows = this.rows.concat({
        rae: this.formulario.value.rae,
        plano: this.formulario.value.plano,
        contenido: this.formulario.value.contenido,
        nota: this.formulario.value.nota,

      })
      localStorage.setItem("Listado_Planos", JSON.stringify(this.rows));
      this.formulario.reset();
    }




  }

  get_clasificacion(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.temp_clasif.id = id;
        this.temp_clasif.rae = this.rows[x].rae;
        this.temp_clasif.plano = this.rows[x].plano;
        this.temp_clasif.contenido = this.rows[x].contenido;
        this.temp_clasif.nota = this.rows[x].nota;


        this.dialog.open(this.openModal);
      }
    }
  }

  cleanData() {
    this.temp_clasif = {
      rae: "",
      plano: "",
      contenido: "",
      nota: "",
    };
  }

  saveclasificacion() {
    var id = this.temp_clasif.id;
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("Listado_Planos", JSON.stringify(this.rows));

        $("#clasif_modal").modal("hide");
        this.actualRow = localStorage.getItem("Listado_Planos");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
          rae: this.temp_clasif.rae,
          plano: this.temp_clasif.plano,
          contenido: this.temp_clasif.contenido,
          nota: this.temp_clasif.nota,

        })
        localStorage.setItem("Listado_Planos", JSON.stringify(this.rows));
        this.temp_clasif = {
          rae: "",
          plano: "",
          contenido: "",
          nota: "",
        };
        this.dialog.closeAll();
      }
    }
  }

  delete_clasificacion(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("Listado_Planos", JSON.stringify(this.rows));
      }
    }
    this.actualRow = localStorage.getItem("Listado_Planos");
    this.rows = JSON.parse(this.actualRow);
  }

}
